<div class="container" *ngIf="isDataForAllSig$()&&(questionsData$()?.length ?? 0) > 0 else noReply">
  <div class="overflow-scroll">
    <div *ngFor="let questionData of questionsData$()">
      <que-answers-in-diagram *ngIf="isDiagramType(questionData.question.type.id)" [questionData]="questionData">
      </que-answers-in-diagram>
      <que-answers-in-rows *ngIf="isRowsType(questionData.question.type.id)" [questionData]="questionData">
      </que-answers-in-rows>
      <que-answers-in-table-or-group *ngIf="isTableType(questionData.question.type.id)" [questionData]="questionData">
      </que-answers-in-table-or-group>
      <que-answers-in-range *ngIf="isRangeType(questionData.question.type.id)" [questionData]="questionData">
      </que-answers-in-range>
    </div>
  </div>
</div>
<ng-template #noReply>
  <que-no-result *ngIf="(!loadingData$() && isLoadedCurretStep$()) else load" [isData]="true"
    [noCommentsForPage]="isDataForAllSig$()"></que-no-result>
</ng-template>
<ng-template #load>
  <div class="load-warp ">
    <div class="load-item" *ngFor="let _ of [].constructor(4)"></div>
  </div>
</ng-template>